<div class="bg-white rounded-xl border border-slate-100 shadow-sm p-5 mb-4">
    <!-- Header -->
    <div class="flex items-center justify-between gap-3 mb-4">
        <div class="flex items-center gap-3 min-w-0">
            <div class="bg-blue-50 text-blue-600 p-2 rounded-lg flex">
                <mat-icon>timeline</mat-icon>
            </div>
            <h3 class="text-base font-semibold text-slate-900 truncate m-0">{{ pattern.name }}</h3>
            @if (pattern.isActive) {
            <span class="shrink-0 bg-emerald-50 text-emerald-700 text-xs font-medium px-2 py-1 rounded">Active</span>
            } @else {
            <span class="shrink-0 bg-slate-100 text-slate-600 text-xs font-medium px-2 py-1 rounded">Inactive</span>
            }
        </div>
        <div class="flex items-center shrink-0">
            <button mat-icon-button (click)="onEdit()" title="Edit">
                <mat-icon class="text-slate-500">edit</mat-icon>
            </button>
            <button mat-icon-button (click)="onDelete()" title="Delete">
                <mat-icon class="text-red-500">delete</mat-icon>
            </button>
        </div>
    </div>

    <!-- Summary -->
    <dl class="grid grid-cols-[8rem_1fr] gap-x-4 gap-y-3 items-center text-sm m-0">
        <dt class="text-slate-500">Action</dt>
        <dd class="m-0">
            <span class="inline-block bg-blue-50 text-blue-700 text-xs font-medium px-2 py-1 rounded">
                {{ getActionLabel(pattern.action) }}
            </span>
        </dd>

        <dt class="text-slate-500">Vehicle flow</dt>
        <dd class="m-0 flex flex-wrap items-center gap-2">
            <span class="bg-slate-100 text-slate-700 text-xs font-medium px-2 py-1 rounded">
                {{ getZoneDisplay(pattern.sourceZoneId) }}
            </span>
            <mat-icon class="flow-arrow text-slate-400">arrow_forward</mat-icon>
            <span class="bg-slate-100 text-slate-700 text-xs font-medium px-2 py-1 rounded">
                {{ getZoneDisplay(pattern.targetZoneId) }}
            </span>
        </dd>

        @if (pattern.parkingSpaceId) {
        <dt class="text-slate-500">Parking space</dt>
        <dd class="m-0 text-slate-900">{{ getParkingSpaceDisplay(pattern.parkingSpaceId) }}</dd>
        }

        @if (pattern.priority) {
        <dt class="text-slate-500">Priority</dt>
        <dd class="m-0 text-slate-900">{{ pattern.priority }}</dd>
        }

        @if (pattern.maxSequenceDurationSeconds) {
        <dt class="text-slate-500">Max duration</dt>
        <dd class="m-0 text-slate-900">{{ pattern.maxSequenceDurationSeconds }} s</dd>
        }

        @if (pattern.description) {
        <dt class="text-slate-500 self-start">Description</dt>
        <dd class="m-0 text-slate-700">{{ pattern.description }}</dd>
        }
    </dl>

    <!-- Steps -->
    <div class="mt-4 border-t border-slate-100 pt-3">
        <button type="button" (click)="showSteps.set(!showSteps())"
            class="w-full flex items-center justify-between text-sm font-medium text-slate-700 hover:text-blue-600">
            <span>Steps ({{ pattern.steps?.length || 0 }})</span>
            <mat-icon class="text-slate-400">{{ showSteps() ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>

        @if (showSteps()) {
        @if (sortedSteps.length > 0) {
        <table class="w-full mt-2 text-sm">
            <thead>
                <tr class="text-left text-xs font-semibold text-slate-500 uppercase">
                    <th class="py-1.5 pr-2 w-8">#</th>
                    <th class="py-1.5 pr-2">Point</th>
                    <th class="py-1.5 pr-2">Direction</th>
                    <th class="py-1.5 pr-2">Plate</th>
                    <th class="py-1.5">Required</th>
                </tr>
            </thead>
            <tbody>
                @for (step of sortedSteps; track step.id ?? $index) {
                <tr class="border-t border-slate-100">
                    <td class="py-2 pr-2 text-slate-400">{{ step.stepOrder }}</td>
                    <td class="py-2 pr-2 text-slate-900">{{ step.detectionPoint?.name ?? '—' }}</td>
                    <td class="py-2 pr-2 text-slate-700">{{ step.expectedDirection || 'N/A' }}</td>
                    <td class="py-2 pr-2 text-slate-700">{{ step.platePosition || 'N/A' }}</td>
                    <td class="py-2">
                        @if (isStepRequired(step)) {
                        <span class="bg-emerald-50 text-emerald-700 text-xs font-medium px-2 py-0.5 rounded">Yes</span>
                        } @else {
                        <span class="bg-slate-100 text-slate-600 text-xs font-medium px-2 py-0.5 rounded">No</span>
                        }
                    </td>
                </tr>
                }
            </tbody>
        </table>
        } @else {
        <p class="text-sm text-slate-400 italic mt-2 mb-0">No steps</p>
        }
        }
    </div>
</div>
